import OImage from './OImage'

export default OImage
